export default __webpack_public_path__ + "static/media/stack-mobile.70742d68.jpg";